import { HTTPClient } from "./Client";

const AvisoApi = {
  async ObterTodosAvisosAsync(pagina, titulo, descricao) {
    const avisosComPaginacao = {
      Pagina: pagina,
      Titulo: titulo,
      Descricao: descricao,
    };

    const response = await HTTPClient.post(
      `/Aviso/ObterTodosAvisosPaginacaoIndividual`,
      avisosComPaginacao
    );

   
    return response.data;
  },

  async CriarAvisoAsync(titulo, descricao, tipoAvisoEnum, usuariosId) {
   
    const avisoCriarRequisicao = {
      Titulo: titulo,
      Descricao: descricao,
      TipoAvisoEnum: tipoAvisoEnum,
      UsuariosId: usuariosId ?? [],
    };

    await HTTPClient.post(`/Aviso/AdicionarAviso`, avisoCriarRequisicao);
  },

  async RemoverAvisoAsync(avisoId) {
    
    await HTTPClient.put(`/Aviso/DesativarAviso/${avisoId}`);
  },

  async VisualizarAvisoAsync(avisoId) {
    const response = await HTTPClient.get(
      `/Aviso/ObterInformacoesPorAvisoId/${avisoId}`
    );

    return response.data;
  },
};

export default AvisoApi;
